import { Tag } from '@equip.health/ui';
import {
  RiskLevel,
  RiskLevelToShortLabel,
  RiskLevelToTagColors,
} from './RiskLevel';
export type AssessmentListCardItemRiskLevelTagProps = {
  id: string;
  riskLevel: RiskLevel;
};
export const AssessmentListCardItemRiskLevelTag = ({
  id,
  riskLevel,
}: AssessmentListCardItemRiskLevelTagProps) => {
  return (
    <Tag
      color={RiskLevelToTagColors[riskLevel]}
      id={`assessment-list-card-risk-tag-${id}`}
      size="sm"
      value={RiskLevelToShortLabel[riskLevel]}
    />
  );
};
